import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _compact from "lodash/compact";
import _values from "lodash/values";
import _every from "lodash/every";
import { mapGetters } from 'vuex';
import StoreAvailability from '~/services/store';
import validateZipcode from '~/helpers/postalCode-validator-helper';
import LineOnSideHeader from '~/components/atoms/LineOnSideHeader.vue';
import TextField from '~/components/atoms/TextField.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/loupe.svg';

const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

const MANDATORY_FIELDS = ['zipcode'];
export default {
  name: 'StoreAvailabilityModal',
  components: {
    MdmModal,
    LineOnSideHeader,
    TextField
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      page: 1,
      stores: null,
      values: {
        zipcode: null
      },
      pendingRequest: false,
      formSuccess: false,
      showServerError: false,
      submitted: false,
      errors: {
        zipcode: false,
        zipcodeFormat: false
      }
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    zipcodeErrorMessage() {
      return this.errors.zipcodeFormat ? this.$t('field_zip_code_invalid_error') : '';
    }

  }),
  watch: {
    values: {
      handler() {
        if (!this.submitted) {
          return;
        }

        this.validateMandatoryFields();
      },

      deep: true
    },
    'values.zipcode': function watchZipcode() {
      this.errors.zipcodeFormat = false;
    }
  },

  mounted() {
    setTimeout(() => {
      if (window.woosmap) {
        const provider = new window.woosmap.ZipCodeProvider();
        this.values.zipcode = provider.getZipCode();
      }
    }, 500);
  },

  methods: {
    validateZipcode() {
      const isoMarket = this.locale.iso.slice(-2);
      this.errors.zipcodeFormat = this.values.zipcode ? !validateZipcode(this.values.zipcode, isoMarket) : false;
    },

    validateMandatoryFields() {
      MANDATORY_FIELDS.forEach(field => {
        this.errors[field] = !this.values[field];
      });
    },

    onSubmit() {
      this.submitted = true;
      this.validateMandatoryFields();
      this.validateZipcode();

      if (_every(this.errors, field => !field)) {
        this.pendingRequest = true;
        this.page = 1;
        const stockClasses = {
          shop_stock_available: 'available',
          shop_stock_limited: 'limited',
          shop_stock_unavailable: 'unavailable'
        };
        StoreAvailability(this.$store, this.product.reference, this.values.zipcode).then((_ref) => {
          let {
            shops
          } = _ref;
          this.stores = _values(shops).map(e => ({
            id: e.id,
            city: e.city,
            address: _compact([e.address, e.address2, e.address_complement]),
            phone: e.phone,
            distance: e.dist,
            distanceLabel: "".concat(e.dist, " km"),
            stockStatus: e.stock_status_label,
            stockClass: stockClasses[e.stock_status]
          }));
          this.pendingRequest = false;
          this.submitted = false;
        });
      }
    },

    more() {
      this.page = this.page + 1;
    }

  }
};